import { useParams } from 'react-router-dom';
import { CardEdit } from './CardEdit';

import { CardForm } from './CardEdit/CardForm';

export const CardFormPage = () => {
  const { id } = useParams<{ id: string }>();

  if (id) {
    // Update existing card
    return <CardEdit />;
  }

  // Create new card
  return <CardForm />;
};
